export * from './objekt-arts.page';
export * from './objekt-arts.page.resolver';
